"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Day = void 0;
var React = __importStar(require("react"));
var components_1 = require("..");
var useDay_1 = require("./hooks/useDay");
/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */
function Day(props) {
    var buttonRef = React.useRef(null);
    var day = useDay_1.useDay(props.date, props.displayMonth, buttonRef);
    var buttonProps = day.buttonProps, nonInteractiveProps = day.nonInteractiveProps;
    if (!buttonProps && !nonInteractiveProps) {
        return React.createElement(React.Fragment, null);
    }
    if (nonInteractiveProps) {
        return React.createElement("div", __assign({}, nonInteractiveProps));
    }
    return React.createElement(components_1.Button, __assign({ ref: buttonRef }, buttonProps));
}
exports.Day = Day;
//# sourceMappingURL=Day.js.map